const mapStateToProps = (state) => {
    const {
        user:{
            isLoggedIn,
        }={},
        api:{
            user,
        }={},
    } = state;
    return { isLoggedIn, user }
}

export default mapStateToProps;